<template lang="html">

  <form class="formulario" id="formContacto" @submit.prevent="validateBeforeSubmit">

    <div class="contenedor-input">
      <label for="">{{$t('formulario.nombre_apellidoslabel')}}</label>
      <input type="text" class="input-text"
      v-validate="'required'"
      name="nombre" :placeholder="$t('formulario.nombre_apellidos')+'*'"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
    </div>

    <div class="contenedor-input">
      <label for="">{{$t('formulario.empresaLabel')}}</label>
      <input type="text" class="input-text"
      v-validate="'required'"
      name="empresa" :placeholder="$t('formulario.empresa')+'*'"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
    </div>


    <div class="contenedor-input">
      <label for="">{{$t('formulario.emailLabel')}}</label>
      <input type="text" class="input-text"
      v-validate="'required|email'"
      name="email" :placeholder="$t('formulario.email')+'*'"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
    </div>

    <div class="contenedor-input">
      <label for="">{{$t('formulario.tfno')}}</label>
      <input type="text" class="input-text"
      v-validate="'length:9'"
      name="telefono" :placeholder="$t('formulario.telefono')"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('telefono') }}</span>
    </div>


    <div class="contenedor-input">
      <label for="">{{$t('formulario.mensajeLabel')}}</label>
      <textarea :placeholder="$t('formulario.mensaje')+'*'"
      name="mensaje" v-validate="'required'"></textarea>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('mensaje') }}</span>
    </div>

    <div class="contenedor-check">
      <input type="checkbox" id="politica-contacto" v-validate="'required'" name="politica">
      <label for="politica-contacto">{{$t('banner_newsletter.HeLeidoYacepto')}}<router-link target="_blank" :to="$t('enlaces.politica_privacidad')">{{$t('banner_newsletter.politica')}}</router-link></label>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
    </div>

    <input type="hidden" name="from" value="iformalia">

    <button class="btn-rounded-blue">{{$t('formulario.enviar')}}</button>

    <h4 class="gracias">Enviado correctamente</h4>

  </form>

</template>

<script lang="js">


  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  Vue.use(VeeValidate);

  import {mapGetters, mapActions} from 'vuex'

  export default  {
    name: 'formulario',
    props: [],
    mounted() {

    },
    data() {
      return {
        clicked : false
      }
    },
    methods: {
      ...mapActions(['sendContacto', 'setLoading']),
      validateBeforeSubmit : function(){

        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if(canSend){
            this.setLoading(true);
            this.sendContacto($("#formContacto").serialize())
            .then(result =>{
              this.setLoading(false);
              $("#formContacto .btn-rounded-blue").addClass('animated fadeOutUp');
              $(".gracias").addClass('animated fadeInUp');
              $("#formContacto")[0].reset();
            });
          }
        });
      },
    },
    computed: {

    }
  }
</script>

<style scoped >

form{
  position: relative;
  margin-top: 30px;
}

h2{
  text-align: left;
  color: #41566d;
  margin-bottom: 20px;
}

p{
  color: #41566d;
  text-align: left;
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 30px;
}

.contenedor-input {
  width: 100%;
  padding-bottom: 20px;
  position: relative;
}

.contenedor-input label{
  width: 100%;
  font-family: 'Ubuntu Mono';
  font-size: 18px;
  line-height: 28px;
  color: #FFFFFF;
  display: inline-block;
  text-align: left;
  margin-bottom: 5px;
}

.contenedor-input input,
.contenedor-input textarea,
.contenedor-input select{
  width: 100%;
  text-align: left;
  padding: 0 15px;
  background: rgba(255,255,255,.8);
  height: 40px;
  line-height: 40px;
  border: 1px solid #FFFFFF;
  outline: none;
  color:#3374b0;
}

.contenedor-input textarea{
  height: 160px;
  resize: none;
}

.contenedor-input input::placeholder,
.contenedor-input textarea::placeholder{
  color: #3374b0;
}

.dropdown{
  width: 40px;
  height: 40px;
  background: url(/static/img/next-blue.svg) center/13px no-repeat;
  position: absolute;
  right: 0;
  bottom: 20px;
  transform: rotate(90deg);
}

.btn-rounded-blue{
  min-width: 150px;
  outline: none;
  margin-top: 20px;
  color:white;
  border-color:white;
}

.contenedor-check{
  padding-bottom: 15px;
}

.contenedor-check label{
  color: #FFFFFF;
}

.contenedor-check label::before{
  border-color: #FFFFFF;
}

.contenedor-check input:checked + label::before{
  color: #FFFFFF;
}


.error{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  color: #df1517;
  font-size: 12px;
  text-align: left;
}

.gracias{
  position: absolute;
  left: 0;
  bottom: 0;
  height: 55px;
  line-height: 55px;
  text-align: center;
  width: 100%;
  font-family: 'Ubuntu Mono';
  font-size: 24px;
  color: #3374b0;
  text-transform: uppercase;
  opacity: 0;
  pointer-events: none;
}

@media screen and (max-width: 600px){
  p{
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 20px;
  }

  .contenedor-input label{
    font-size: 14px;
    line-height: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/view-parts/contacto/formulario.vue